import { Box } from '@chakra-ui/react'
import { ContentNode } from '@helo/cms'

import { Icon } from '../../components/Icons/Icon'
import { IconTypes } from '../../components/Icons/icon-registry'
import { SkeletonCircle } from '../../components/SkeletonLoader'
import { createWidget } from '../widget-utils'

export interface ModeIconWidgetProps {
  contentNode: ContentNode
  boxSize?: string
  color?: string
  isLoading?: boolean
}

export const ModeIconWidget = ({
  contentNode,
  boxSize = '28px',
  color = 'presets.neutral.90',
  isLoading,
}: ModeIconWidgetProps) => {
  // Extract the mode value from contentNode data
  const modeValue = contentNode?.data

  // Map mode type to appropriate icon name
  const getIconName = (): IconTypes => {
    if (!modeValue) {
      return 'ShipmentsIcon'
    }

    const mode = String(modeValue).toLowerCase()
    switch (mode) {
      case 'ocean':
        return 'OceanShipmentsIcon'
      case 'air':
        return 'AirShipmentsIcon'
      case 'trucking':
        return 'TruckingShipmentsIcon'
      default:
        return 'ShipmentsIcon'
    }
  }

  const iconName = getIconName()

  if (isLoading) {
    return <SkeletonCircle isLoading size={boxSize} />
  }

  return (
    <Box color={color}>
      <Icon icon={iconName} boxSize={boxSize} />
    </Box>
  )
}

export const ModeIconWidgetDefinition = createWidget(ModeIconWidget, {
  type: 'ModeIcon',
})
